<template>
    <div>
        <div class="grid-x grid-padding-x">
            <div class="cell auto crop-container" :style="{ backgroundImage: 'url(' + this.image + ')' }">

                <slim-cropper
                  :options="slimOptions"
                >
				<input type="file">
               </slim-cropper>
               <input type="hidden" :name="fieldname" :value="uploadedFile">
            </div>
        </div>

    </div>
</template>

<script>
import Slim from "../vendor/slim/slim.vue";
import Cookies from "js-cookie";

export default {
  name: "slim-uploader",
  props: {
    fieldname: { required: true },
    label: {
      required: false,
      default: "Upload"
    },
    size: {
      required: false,
      default: false
    },
    service: {
      required: true
    },
    required: {
      required: false,
      default: false
    },
    image: {
      required: false
    },
    push: {
      required: false,
      default: false
    },
    ratio: {
      required: false,
      default: "free"
    }
  },
  methods: {
    afterRemove: function(error, data) {
      this.$emit("afterRemove");
    },
    afterUpload: function(error, data, response, slim) {
      slim._output.value = response.path;
      this.uploadedFile = response.path;
      this.$emit("afterUpload", response);
    },
    handleRequest: function(xhr) {
      let token = Cookies.get("csrfToken");
      if (token) {
        xhr.setRequestHeader("X-CSRF-Token", token);
      }
    }
  },
  computed: {},
  components: {
    "slim-cropper": Slim
  },
  data() {
    return {
      slimOptions: {
        ratio: "1:1",
        service: this.service,
        defaultInputName: 'slim',
        push: this.push,
        didUpload: this.afterUpload,
        didRemove: this.afterRemove,
        // initialImage: this.image, // this is not set because we use a background image
		// instead so images from the CDN work nicely with slim
        ratio: this.ratio,
        willRequest: this.handleRequest
      },
      uploadedFile: null
    };
  }
};
</script>

<style lang="scss">
	.crop-container {
		background-size: contain;
		background-position: center center;
		background-repeat: no-repeat;

		.slim {
			background-color: rgba(0,0,0, 0);
		}
	}

	.shrink img {
		max-height: 11rem;
	}
</style>